













import { Vue, Prop, Component } from 'vue-property-decorator';

import Team from './partials/Team.vue';

@Component({
  components: { Team }
})
export default class Teams extends Vue {
  @Prop() private data!: any;
}
